import { createRoot } from "react-dom/client";
import App from "./App";
import "./landing.css";
import { captureDeferredInstallPrompt, clearDeferredInstallPrompt } from "./lib/pwaInstall";

const markStartup = (name: string) => performance.mark?.(`iraq-gold:${name}`);
const setBootProgress = (value: number, label: string) => {
  window.__IRAQ_GOLD_SET_BOOT_PROGRESS__?.(value, label);
};
markStartup("js-start");
setBootProgress(38, "جارٍ تشغيل التطبيق");

setBootProgress(52, "جارٍ تجهيز الخدمات");

if (typeof window !== "undefined" && "serviceWorker" in navigator && (window.location.protocol === "https:" || window.location.hostname === "localhost")) {
  window.addEventListener("load", () => {
    markStartup("window-load");
    markStartup("service-worker-register-start");
    void navigator.serviceWorker.register("/notification-sw.js?v=12", { scope: "/", updateViaCache: "none" }).then(registration => {
      markStartup("service-worker-registered");
      registration.waiting?.postMessage({ type: "SKIP_WAITING" });
      void registration.update();
      return navigator.serviceWorker.ready;
    }).then(() => {
      markStartup("service-worker-ready");
    }).catch(error => {
      console.warn("[PWA] Service Worker registration failed", error);
    });
  }, { once: true });
}

setBootProgress(72, "جارٍ تجهيز الواجهة");

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", captureDeferredInstallPrompt);
  window.addEventListener("appinstalled", clearDeferredInstallPrompt);
}

createRoot(document.getElementById("root")!).render(<App />);
markStartup("react-render-called");
setBootProgress(84, "جارٍ عرض البيانات");
